import type { B2gContract, B2gContractSignatureBody } from '@mathflat/domain/Academy'
import { makeAutoObservable } from 'mobx'

import commonRepo from '@/repository/common.repo'
import { typeSafeAssign } from '@/utils/common'

export type ContractInfo = {
  academyId: B2gContract['academyId'] | null
  schoolName: string
  amount: B2gContract['amount']
  contractStartDateTime: B2gContract['contractStartDateTime'] | null
  contractEndDateTime: B2gContract['contractEndDateTime'] | null
  subscribePlan: B2gContract['subscribePlan'] | null
  studentCount: B2gContract['studentCount']
  teacherSignature?: B2gContractSignatureBody['teacherSignature']
  schoolNameSignature?: B2gContractSignatureBody['schoolNameSignature']
}

export class ContractPdfService {
  contractInfo: ContractInfo = {
    academyId: commonRepo.b2gContract?.academyId || null,
    schoolName: commonRepo.b2gContract?.schoolName || '',
    amount: commonRepo.b2gContract?.amount || 0,
    subscribePlan: commonRepo.b2gContract?.subscribePlan || null,
    studentCount: commonRepo.b2gContract?.studentCount || 0,
    contractStartDateTime: commonRepo.b2gContract?.contractStartDateTime || null,
    contractEndDateTime: commonRepo.b2gContract?.contractEndDateTime || null,
    teacherSignature: '',
    schoolNameSignature: '',
  }
  contractPdfInfo?: ContractInfo
  pdfClient: { connected: boolean } = {
    connected: false,
  }
  constructor(data?: Partial<ContractPdfService>) {
    if (data) typeSafeAssign(this, data)
    makeAutoObservable(this)
  }
  get pdfDataRenderData() {
    return {
      ...this.contractInfo,
    }
  }
}
